import { request } from '@api/request'
import { AxiosResponse } from 'axios'
import { MapEventDTO } from '@models/api/MapEventDTO'
import { Dayjs } from 'dayjs'

export const mapEvent = {
  getMapEvents: async function (
    startTime: Dayjs,
    endTime: Dayjs
  ): Promise<MapEventDTO[]> {
    try {
      const result: AxiosResponse<MapEventDTO[]> = await request.get(
        `mapEvent`,
        {
          params: {
            start_time: startTime.utc().toISOString(),
            end_time: endTime.utc().toISOString()
          }
        }
      )
      return result.data
    } catch (error) {
      return Promise.reject(error)
    }
  },

  putMapEvent: function (mapEvent: MapEventDTO) {
    return request.put(`mapEvent/${mapEvent.ID_MAP_EVENT}`, mapEvent)
  },

  deleteMapEvent: function (mapEvent: MapEventDTO) {
    return request.delete(`mapEvent/${mapEvent.ID_MAP_EVENT}`)
  }
}
